import * as Sentry from '@sentry/react'
// import toast from 'react-hot-toast'

export const FrontEndError = (err: Error) => {
    console.log('FRONTEND ERROR -->', JSON.stringify(err))
    // toast.error('Something went wrong')
    Sentry.captureException(err)
}
